import React from 'react'
import {useTranslation} from 'react-i18next'
import {Layout, Typography} from 'antd'
import moment from 'moment'
import {observer} from 'mobx-react'
import classNames from 'classnames'
import {useInjection} from 'dna-react-ioc'
import {COMPANY_NAME} from '@/constants/app'
import {Links} from '@/components'
import {Cookies} from '@/components/composite/Cookies/Cookies'
import {useScreenType} from '@/hooks'
import {TFooterStore} from './TFooterStore'
import styles from './styles.scss'

export const FooterStoreSymbol = Symbol('FooterStore')

export const Footer = observer(() => {
    const {t} = useTranslation()
    const {isMobile} = useScreenType()
    const store = useInjection<TFooterStore>(FooterStoreSymbol)
    const versionStr = _LAST_COMMIT_HASH_ || ''

    return (
        <Layout.Footer className={classNames(styles.footer, {[styles.footerMobile]: isMobile})}>
            <Cookies
                open={store.open}
                statisticsChecked={store.statisticsChecked}
                setStatisticsChecked={store.setStatisticsChecked}
                onSaveClick={store.onSaveClick}
                onEssentialClick={store.onEssentialClick}
                onAllAcceptClick={store.onAllAcceptClick}
            />
            <Links onCookiesClick={() => store.setOpen(true)} />
            <div>
                © {moment().year()} {COMPANY_NAME}
            </div>
            {versionStr ? (
                <Typography.Text className={styles.version} type={'secondary'}>
                    {t('Footer.version')} {versionStr}
                </Typography.Text>
            ) : null}
        </Layout.Footer>
    )
})
